var _rect, _rect2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1534,
    height: 942,
    viewBox: "0 0 1534 942",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 4,
    width: 1534,
    height: 938,
    fill: "url(#paint0_linear_62_993)",
    fillOpacity: 0.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.00012207,
    y: -0.000244141,
    width: 1534,
    height: 942,
    fill: "url(#paint1_linear_62_993)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M690.015 -7.2149L690.022 962.768L835.013 962.764L835.006 -7.21899L690.015 -7.2149Z",
    fill: "#B0ECE6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M690.015 363.533L690.017 590.674L835.01 590.67L835.009 363.529L690.015 363.533Z",
    fill: "#B0ECE6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M690.015 590.674L690.018 959.251L834.994 959.247L834.991 590.67L690.015 590.674Z",
    fill: "#B0ECE6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M-269.881 959.688L690.03 959.675L690.017 -3.99997L689.451 -3.99997C159.618 -3.99731 -269.888 427.464 -269.881 959.688Z",
    fill: "#B0ECE6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M97.1437 960.191L690.03 960.183L690.021 363.533L689.67 363.533C532.475 363.584 381.738 426.475 270.618 538.369C159.498 650.264 97.0979 801.997 97.1437 960.191Z",
    fill: "#B0ECE6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M323.005 959.586L690.03 959.581L690.025 590.675L689.806 590.675C592.494 590.706 499.18 629.59 430.392 698.774C361.604 767.959 322.975 861.775 323.005 959.586Z",
    fill: "#B0ECE6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1198.69 -1.8642L834.981 -1.85934L834.985 363.719L835.202 363.719C931.636 363.688 1024.11 325.154 1092.28 256.594C1160.44 188.034 1198.72 95.064 1198.69 -1.8642Z",
    fill: "#B0ECE6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1198.69 -1.8564L1422.51 -1.86426C1422.56 154.974 1360.72 305.406 1250.6 416.341C1140.49 527.277 991.109 589.628 835.332 589.679H834.983L834.98 363.903H835.197C931.631 363.873 1024.1 325.321 1092.27 256.73C1160.44 188.139 1198.72 95.1266 1198.69 -1.84566V-1.8408V-1.8564Z",
    fill: "#B0ECE6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1198.69 -1.8564L1422.51 -1.86426C1422.56 154.974 1360.72 305.406 1250.6 416.341C1140.49 527.277 991.109 589.628 835.332 589.679H834.983L834.98 363.903H835.197C931.631 363.873 1024.1 325.321 1092.27 256.73C1160.44 188.139 1198.72 95.1266 1198.69 -1.84566V-1.8408V-1.8564Z",
    fill: "#B0ECE6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1422.66 -1.85985L1786.46 -1.86426C1786.47 525.833 1360.73 953.626 835.546 953.628H834.985L834.98 589.724H835.329C991.145 589.674 1140.56 527.318 1250.71 416.375C1360.85 305.432 1422.7 154.989 1422.66 -1.85985Z",
    fill: "#B0ECE6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1422.66 -1.85985L1786.46 -1.86426C1786.47 525.833 1360.73 953.626 835.546 953.628H834.985L834.98 589.724H835.329C991.145 589.674 1140.56 527.318 1250.71 416.375C1360.85 305.432 1422.7 154.989 1422.66 -1.85985Z",
    fill: "#B0ECE6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1422.66 -1.85985L1786.46 -1.86426C1786.47 525.833 1360.73 953.626 835.546 953.628H834.985L834.98 589.724H835.329C991.145 589.674 1140.56 527.318 1250.71 416.375C1360.85 305.432 1422.7 154.989 1422.66 -1.85985Z",
    fill: "#B0ECE6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_62_993",
    x1: 1603.73,
    y1: -16.9375,
    x2: 154.8,
    y2: 1683.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_62_993",
    x1: 767.008,
    y1: 941.994,
    x2: 767.008,
    y2: -0.000244141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000490735,
    stopColor: "#05295D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041F46"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.2a4659f48349124cb369cd30bb83277c.svg";
export { ForwardRef as ReactComponent };